import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import {
  signupUser,
  OtpUser,
  // loginUser,
  requestPasswordReset,
  confirmPasswordReset,
} from "./Apiservice";
import Modal from "react-modal";
const AuthForm = () => {
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [showloginPassword, setShowloginPassword] = useState(false);
  const [registerData, setRegisterData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const getCookie = (name) => {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const csrftoken = getCookie("csrftoken");

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://ardorbiomed.com/api/api/login/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrftoken, // Ensure csrftoken is defined correctly
        },
        body: JSON.stringify(loginData),
      });

      if (!response.ok) {
        throw new Error("Login failed. Please check your credentials.");
      }

      const data = await response.json();
      const userId = data.user.user_id; // Extract user ID

      // Merge guest cart with user cart after login
      await mergeCartsAfterLogin(userId);

      Swal.fire({
        icon: "success",
        title: "Login Successful",
        text: "You are now logged in.",
        confirmButtonText: "OK",
      }).then(() => {
        localStorage.setItem("userId", userId);
        localStorage.setItem("username", data.user.username);
        localStorage.setItem("accessToken", data.access);
        window.location.href = "/";
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: error.message,
        confirmButtonText: "OK",
      });
    }
  };

  const mergeCartsAfterLogin = async (userId) => {
    try {
      const response = await fetch(
        "https://ardorbiomed.com/api/api/cart/merge/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ user_id: userId }), // Pass user_id explicitly
          credentials: "include",
        }
      );

      const data = await response.json();
      if (response.ok && data.merged_count > 0) {
        console.log(
          `${data.merged_count} items from your guest cart were added to your account.`
        );
      }
    } catch (err) {
      console.error("Error merging carts:", err);
    }
  };

  // const handleLogin = (e) => {
  //   e.preventDefault();

  //   fetch("https://ardorbiomed.com/api/api/login/", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "X-CSRFToken": csrftoken,
  //     },
  //     body: JSON.stringify(loginData),
  //   })
  //     .then((response) => {
  //       if (response.ok) {
  //         return response.json();
  //       }
  //       throw new Error("Login failed. Please check your credentials.");
  //     })
  //     .then((data) => {
  //       Swal.fire({
  //         icon: "success",
  //         title: "Login Successful",
  //         text: "You are now logged in.",
  //         confirmButtonText: "OK",
  //       }).then(() => {
  //         localStorage.setItem("userId", data.user.user_id);
  //         localStorage.setItem("username", data.user.username);
  //         localStorage.setItem("accessToken", data.access);
  //         window.location.href = "/";
  //       });
  //     })
  //     .catch((error) => {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Login Failed",
  //         text: error.message,
  //         confirmButtonText: "OK",
  //       });
  //     });
  // };

  const toggleloginPassword = () => {
    setShowloginPassword(!showloginPassword);
  };
  const [showregisterNewPassword, setShowregisterNewPassword] = useState(false);
  const [showregisterConfirmPassword, setShowregisterConfirmPassword] =
    useState(false);
  const handleRegister = async (e) => {
    e.preventDefault();

    if (registerData.password !== registerData.confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Passwords do not match",
        confirmButtonText: "Try Again",
      });
      return;
    }

    try {
      const payload = {
        username: registerData.username,
        email: registerData.email,
        password: registerData.password,
        confirm_password: registerData.confirmPassword,
        mobile: registerData.mobile,
      };

      const response = await signupUser(payload);
      console.log("Registration response:", response);

      Swal.fire({
        icon: "success",
        title: "Registration Successful",
        text: "Please verify your OTP.",
        confirmButtonText: "OK",
      }).then(() => {
        setEmailForOtp(registerData.email);
        setRegisterData({
          username: "",
          email: "",
          password: "",
          confirmPassword: "",
          mobile: "",
        });
        setIsOtpModalOpen(true);

        // Store user email and password for auto-login after OTP verification
        localStorage.setItem("userEmail", registerData.email);
        localStorage.setItem("userPassword", registerData.password);
      });
    } catch (error) {
      let errorMessage = "Registration failed. Please try again.";
      if (error.response) {
        if (error.response.data?.confirm_password) {
          errorMessage = error.response.data.confirm_password[0];
        } else if (error.response.data?.mobile) {
          errorMessage = error.response.data.mobile[0];
        } else if (error.response.data?.email) {
          errorMessage = error.response.data.email[0];
        }
      }
      Swal.fire({
        icon: "error",
        title: "Registration Failed",
        text: errorMessage,
        confirmButtonText: "Try Again",
      });
    }
  };

  const toggleregisterNewPassword = () => {
    setShowregisterNewPassword(!showregisterNewPassword);
  };

  const toggleregisterConfirmPassword = () => {
    setShowregisterConfirmPassword(!showregisterConfirmPassword);
  };

  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [emailForOtp, setEmailForOtp] = useState("");
  const handleOtpVerification = async () => {
    try {
      await OtpUser({
        email: emailForOtp,
        code: otp,
      });

      Swal.fire({
        title: "OTP Verified successfully!",
        text: "You have successfully verified your OTP. Please log in.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(async () => {
        setIsOtpModalOpen(false);
        const userEmail = localStorage.getItem("userEmail");
        const userPassword = localStorage.getItem("userPassword");

        const loginResponse = await fetch(
          "https://ardorbiomed.com/api/api/login/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-CSRFToken": csrftoken,
            },
            body: JSON.stringify({
              email: userEmail,
              password: userPassword,
            }),
          }
        );

        if (loginResponse.ok) {
          const data = await loginResponse.json();
          localStorage.setItem("userId", data.user.user_id);
          localStorage.setItem("username", data.user.username);

          // Show success message
          Swal.fire({
            title: "Login Successful",
            text: "You have logged in successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            window.location.href = "/";
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Login Failed",
            text: "Auto-login failed. Please try again.",
            confirmButtonText: "OK",
          });
        }
      });
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "OTP verification failed. Please try again.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
    }
  };

  const [emailforget, setEmailforget] = useState(""); // For forgot password email
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [isResetPasswordOpen, setIsResetPasswordOpen] = useState(false);
  const [emailreset, setEmailreset] = useState("");
  const handleSendResetLinkClick = async () => {
    try {
      await requestPasswordReset(emailforget); // Call the password reset function
      Swal.fire({
        title: "Success!",
        text: "Password reset OTP sent to your email.",
        icon: "success",
        confirmButtonText: "OK",
      });
      setIsForgotPasswordOpen(false);

      setEmailreset(emailforget); // Store the email in state
      setIsResetPasswordOpen(true);
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Failed to send OTP. Please check the email.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
    }
  };
  const [error, setError] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otpreset, setOtpreset] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleResetPasswordSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const userData = {
        email: emailreset, // Use email from reset state
        otp: otpreset,
        new_password: newPassword,
        confirm_password: confirmPassword,
      };
      await confirmPasswordReset(userData);

      Swal.fire({
        title: "Success!",
        text: "Password reset successful. You can now log in.",
        icon: "success",
        confirmButtonText: "OK",
      });
      setEmailreset("");
      setOtpreset("");
      setNewPassword("");
      setConfirmPassword("");
      setIsResetPasswordOpen(false);
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Failed to reset password. Please check your details.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
      console.error(
        "Error details: ",
        error.response ? error.response.data : error.message
      );
    }
  };
  const toggleNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleLogout = () => {
    localStorage.removeItem("userId");
    localStorage.removeItem("username");
    window.location.href = "/";
  };
  const isLoggedIn = localStorage.getItem("userId") !== null;

  const [isRegisterClicked, setIsRegisterClicked] = useState(false);

  const handleRegisterClick = () => {
    setIsRegisterClicked(true);
  };

  const resetBorderColor = () => {
    setIsRegisterClicked(false);
  };
  return (
    <>
      {isLoggedIn ? (
        <div className="user-main">
          <div className="user-card">
            <div className="user-card-header">
              <img
                className="user-card-image"
                src="./assets/img/dummyimg.jpg" // Dummy image
                alt="User"
              />
              <h3>Hi, {localStorage.getItem("username")}</h3>
            </div>
            <div className="user-card-body">
              <button onClick={handleLogout} className="logout-btn">
                Logout
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="auth-container-infi">
          <div className="auth-form">
            <div className="login-section">
              <h2>Login</h2>
              <form onSubmit={handleLogin}>
                <label htmlFor="login-email">Email Address *</label>
                <input
                  type="email"
                  id="login-email"
                  value={loginData.email}
                  onChange={(e) =>
                    setLoginData({ ...loginData, email: e.target.value })
                  }
                  placeholder="Enter your email"
                  required
                />

                <label htmlFor="login-password">Password *</label>
                <div className="password-input-container">
                  <input
                    type={showloginPassword ? "text" : "password"}
                    id="login-password"
                    value={loginData.password}
                    onChange={(e) =>
                      setLoginData({ ...loginData, password: e.target.value })
                    }
                    placeholder="Enter your password"
                    required
                  />
                  <span
                    className="password-togglelogin"
                    onClick={toggleloginPassword}
                  >
                    {showloginPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <div className="login-actions">
                  <button type="submit" className="login-button">
                    Log in
                  </button>
                </div>
                <Link
                  to="#"
                  className="forgot-password"
                  onClick={() => setIsForgotPasswordOpen(true)} // Open modal
                >
                  Forget password?
                </Link>
                <p className="text-center mt-3">
                  If you don't have an account please
                  <span
                    style={{ color: "#6c63ff", cursor: "pointer" }}
                    onClick={handleRegisterClick}
                  >
                    {" "}
                    register?
                  </span>
                </p>
              </form>
            </div>

            <div className="register-section">
              <h2>Register</h2>
              <form onSubmit={handleRegister}>
                <label htmlFor="register-username">Username *</label>
                <input
                  type="text"
                  id="register-username"
                  value={registerData.username}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      username: e.target.value,
                    })
                  }
                  style={{
                    borderColor: isRegisterClicked ? "red" : "",
                    borderWidth: isRegisterClicked ? "1px" : "",
                  }}
                  onFocus={resetBorderColor} // Reset border color on focus
                  placeholder="Enter a username"
                  required
                />

                <label htmlFor="register-email">Email Address *</label>
                <input
                  type="email"
                  id="register-email"
                  value={registerData.email}
                  onChange={(e) =>
                    setRegisterData({ ...registerData, email: e.target.value })
                  }
                  placeholder="Enter your email"
                  required
                  style={{
                    borderColor: isRegisterClicked ? "red" : "",
                    borderWidth: isRegisterClicked ? "1px" : "",
                  }}
                  onFocus={resetBorderColor}
                />

                <label htmlFor="register-mobile">Mobile *</label>
                <input
                  type="text"
                  id="register-mobile"
                  value={registerData.mobile}
                  onChange={(e) =>
                    setRegisterData({ ...registerData, mobile: e.target.value })
                  }
                  placeholder="Enter your mobile number"
                  required
                  style={{
                    borderColor: isRegisterClicked ? "red" : "",
                    borderWidth: isRegisterClicked ? "1px" : "",
                  }}
                  onFocus={resetBorderColor}
                />

                <label htmlFor="register-password">Password *</label>
                <div className="password-input-container">
                  <input
                    type={showregisterNewPassword ? "text" : "password"}
                    id="register-password"
                    value={registerData.password}
                    onChange={(e) =>
                      setRegisterData({
                        ...registerData,
                        password: e.target.value,
                      })
                    }
                    placeholder="Enter your password"
                    required
                    style={{
                      borderColor: isRegisterClicked ? "red" : "",
                      borderWidth: isRegisterClicked ? "1px" : "",
                    }}
                    onFocus={resetBorderColor}
                  />
                  <span
                    className="password-togglelogin"
                    onClick={toggleregisterNewPassword}
                  >
                    {showregisterNewPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                <label htmlFor="register-confirm-password">
                  Confirm Password *
                </label>
                <div className="password-input-container">
                  <input
                    type={showregisterConfirmPassword ? "text" : "password"}
                    id="register-confirm-password"
                    value={registerData.confirmPassword}
                    onChange={(e) =>
                      setRegisterData({
                        ...registerData,
                        confirmPassword: e.target.value,
                      })
                    }
                    placeholder="Confirm your password"
                    required
                    style={{
                      borderColor: isRegisterClicked ? "red" : "",
                      borderWidth: isRegisterClicked ? "1px" : "",
                    }}
                    onFocus={resetBorderColor}
                  />

                  <span
                    className="password-togglelogin"
                    onClick={toggleregisterConfirmPassword}
                  >
                    {showregisterConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <button type="submit" className="register-button">
                  Register
                </button>
              </form>
            </div>
          </div>

          <Modal
            isOpen={isForgotPasswordOpen}
            onRequestClose={() => setIsForgotPasswordOpen(false)}
            contentLabel="Forgot Password"
            className="ModalContent-infi"
            overlayClassName="ModalOverlay-infi"
          >
            <div className="ModalHeader-infi">
              <h2>Reset Your Password</h2>
            </div>
            <div className="ModalDescription-infi">
              <p>
                Please enter your email address to receive a password reset
                link.
              </p>
            </div>
            <input
              type="email"
              value={emailforget}
              onChange={(e) => setEmailforget(e.target.value)}
              className="ModalInput-infi"
              placeholder="Enter your email"
              required
            />
            <button
              onClick={handleSendResetLinkClick}
              className="ModalButton-infi"
            >
              Send Reset Link
            </button>
            <button
              onClick={() => setIsForgotPasswordOpen(false)}
              className="CloseButton-infi"
            >
              Close
            </button>
          </Modal>

          <Modal
            isOpen={isResetPasswordOpen}
            onRequestClose={() => setIsResetPasswordOpen(false)}
            contentLabel="Reset Password"
            className="ModalContent-infi"
            overlayClassName="ModalOverlay-infi"
          >
            <div className="ModalHeader-infi">
              <h2>Reset Your Password</h2>
            </div>
            <form onSubmit={handleResetPasswordSubmit}>
              <div className="ModalDescription-infi">
                <p>Enter the OTP sent to {emailreset}</p>
              </div>
              <input
                type="text"
                value={otpreset}
                onChange={(e) => setOtpreset(e.target.value)}
                className="ModalInput-infi"
                placeholder="Enter OTP"
                required
              />
              <div className="password-input-container">
                <input
                  type={showNewPassword ? "text" : "password"} // Toggle between text and password type
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="ModalInput-infi"
                  placeholder="Enter new password"
                  required
                />
                <span className="password-toggle" onClick={toggleNewPassword}>
                  {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              <div className="password-input-container">
                <input
                  type={showConfirmPassword ? "text" : "password"} // Toggle between text and password type
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="ModalInput-infi"
                  placeholder="Confirm new password"
                  required
                />
                <span
                  className="password-toggle"
                  onClick={toggleConfirmPassword}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              {error && <p style={{ color: "red" }}>{error}</p>}
              <button type="submit" className="ModalButton-infi">
                Reset Password
              </button>
            </form>
            <button
              onClick={() => setIsResetPasswordOpen(false)}
              className="CloseButton-infi"
            >
              Close
            </button>
          </Modal>

          <Modal
            isOpen={isOtpModalOpen}
            onRequestClose={() => setIsOtpModalOpen(false)}
            contentLabel="OTP Verification"
            className="ModalContent-infi" // Modal content
            overlayClassName="ModalOverlay-infi" // Overlay behind modal
          >
            <div className="ModalHeader-infi">
              <h2>Verify OTP</h2>
            </div>
            <div className="ModalDescription-infi">
              <p>Please enter the OTP sent to {emailForOtp}</p>
            </div>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="ModalInput-infi"
              placeholder="Enter OTP"
              required
            />
            <button
              onClick={handleOtpVerification}
              className="ModalButton-infi"
            >
              Verify OTP
            </button>
            <button
              onClick={() => setIsOtpModalOpen(false)}
              className="CloseButton-infi"
            >
              Close
            </button>
          </Modal>
        </div>
      )}
    </>
  );
};

export default AuthForm;
